import { render } from "./trackers.vue?vue&type=template&id=48eb449b&scoped=true&ts=true"
import script from "./trackers.vue?vue&type=script&lang=ts"
export * from "./trackers.vue?vue&type=script&lang=ts"

import "./trackers.vue?vue&type=style&index=0&id=48eb449b&scoped=true&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48eb449b"]])

export default __exports__